import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './Local/en_translation.json';
import deTranslation from './Local/de_translation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      de: {
        translation: deTranslation
      },
    },
    lng: 'de', // default language
    fallbackLng: 'en',  
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
